import routes from './routes';
import { SetRoutes } from 'components';

const PromotionsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default PromotionsPages;
